import { Canvas, Div, H1, Span, Table, TBody, TR, TD, TH, VArray, A } from 'alkali'
import './DashboardStatistics.scss'
import { TermEditorIcon } from '../components/filter/TermEditorIcon'
import { liveQuestion, parameterToQuestion } from 'model/SearchQuery'
import { get } from 'tools/request'
import app from '../app/app'
import { hasInputed } from '../components/search/QuestionBar'

let maxCount = 0
let previousTerm = 'treatment'
function calcMax(count, termClass) {
    if (previousTerm != termClass)
        maxCount = 0
    previousTerm = termClass
    if (count)
        maxCount = Math.max(maxCount, +count)
    else
        return
    return maxCount
}
const widgetContainer = ({stats}) => new Div('.studies-widget', [
    Canvas('#barChart', {width: 320, height: 380})
],
    {
    attached() {
        import('components/dashboardStatistics/DisplayChart').then(({ DisplayBarChart }) => {
            DisplayBarChart(stats, 'studies-sources')
        })
        }
    }
)
const categoriesContainer = () => new Div('.categories-widget', [
    Canvas('#barChartCategories')
], 
    {
    ready() {
        import('components/dashboardStatistics/DisplayChart').then(({ DisplayBarChart }) => {
            get('/portal/SummaryStatistics').then(results => {
                DisplayBarChart(results.diseases, 'studies-categories')
            })
        })
            
    }
})
const TitleSources = ({titleText}) => new Div('.title-widget-sources', [
    H1([titleText])
])
const TitleCategories = ({titleText}) => new Div('.title-widget-categories', [
    H1([titleText])
])
const statContainer = ({ header, dataRows, termClass, includePieChart, odometer, stats, RCTstats }) => new Div('.container', [
    Table([
        TBody([
            TR([
                TH({ colspan: 2}, [
                    H1([header]),
                    Span('.odometer', [0], {
                        attached() {
                            import('odometer').then(odometer => {
                                odometer.init()
                                setTimeout(() => this.innerText = stats, 100)
                            })
                        }
                    }),
            ])])]),
        Div('.term-rows', [
            dataRows.map((dataRow, index) =>
                TR([
                    TD('.term-name.top-' + termClass + '-name',
                    {
                        attached() {
                            if (dataRow.popularity >= 0) {
                                if (app.user != null && app.user.FeatureConfig?.['Bindings Admin']?.Enabled) {
                                    let editor = new TermEditorIcon({ term: dataRow, type: termClass == 'treatment' ? 'intervention' : termClass == 'condition' ? 'characteristic' : 'outcome'})
                                    editor.style.display = 'none'
                                    this.prepend(editor)
                                }
                            }
                        },
                        onmouseover(event) {
                            if (app.user?.FeatureConfig?.['Bindings Admin']?.Enabled && dataRow.termId) {
                                this.children[0].style.display = 'flex'
                                this.children[0].style.position = 'absolute'
                            }
                            // show the hover'ed attribute in the question input
                            if (hasInputed || !this.lastChild.href)
                                return // don't modify user input
                            let question = parameterToQuestion(this.lastChild.href.replace(/.*search=/, ''))
                            liveQuestion.text.is(this.lastChild.textContext)
                        },
                        onmouseout(event) {
                            if (app.user?.FeatureConfig?.['Bindings Admin']?.Enabled && dataRow.termId) {
                                this.children[0].style.display = 'none'
                            }
                        }
                    }, [
                        dataRow.label ? ((dataRow.termId && termClass == 'treatment') ? A : Span)({
                            href:'?search=How_effective_is_(intervention:'+dataRow.termId + ':' + dataRow.label.replace(/ /g, '_') + ')?',
                            title: dataRow.label,
                            'data-id': dataRow.termId,
                        },[dataRow.label]) : null
                    ]),
                    TD('.term-count.top-' + termClass, {
                        'data-count': dataRow.value
                    }, [
                    termClass.includes('study-stat') ? dataRow.value : Div('.term-count-bar', {
                        content: dataRow.popularity,
                        width: 0 + '%',
                        attached() {
                            setTimeout(() => index == 1 ? this.style.width = 'calc(' + (dataRow.popularity / calcMax(dataRow.popularity, termClass) * 90 + 10) + '%' + ' + 4px)' :
                            this.style.width = (dataRow.popularity / calcMax(dataRow.popularity, termClass) * 90 + 10) + '%', 10)
                        }
                    },[dataRow.popularity])
                    ])
                ])
            )])]),
    includePieChart ? Div('#pieChartContainer', [
        Canvas('#pieChart'),
    ], {
        attached() {
            let RCT = RCTstats
            let nonRCT = stats
            nonRCT = nonRCT - RCT
            import('components/dashboardStatistics/DisplayChart').then(({ displayChart }) =>
                displayChart(RCT, nonRCT))
        }
    }) : null,
])

function removeRepeatedTerms(arr) {
    return arr.filter((thing, index, self) =>
        index === self.findIndex((t) => (
            t.label === thing.label && t.popularity === thing.popularity)))
}
export class DashboardStatistics extends Div('.master-container.dashboard-container.section-content.active') {
    created(properties) {
        this.content = new VArray(get('/portal/Statistics').then(
            ({ studyStatRows, topInterventions, topConditions, topOutcomes, statistics, yearCounts, maxCount }) => [
            statContainer({
                header: 'Studies',
                dataRows: studyStatRows,
                termClass: 'study-stat',
                includePieChart: true,
                stats: statistics.studies,
                RCTstats: statistics.rcts
            }),
            statContainer({
                header: 'Treatments',
                dataRows: removeRepeatedTerms(topInterventions),
                termClass: 'treatment',
                stats: statistics.interventions
            }),
            statContainer({
                header: 'Conditions',
                dataRows: removeRepeatedTerms(topConditions),
                termClass: 'condition',
                stats: statistics.conditions,
            }),
            statContainer({
                header: 'Outcomes',
                dataRows: removeRepeatedTerms(topOutcomes),
                termClass: 'outcome',
                stats: statistics.outcomes
            }),
            TitleSources({
                titleText: 'Study Sources'
            }),
            widgetContainer({
                stats: statistics.sourceTypes
            }),
            TitleCategories({
                titleText: 'Studies by Therapeutic Area'
            }),
            categoriesContainer()
        ])
        )
    }
}

